

export default {
    doctor_production: '/api/web/v2/doctorhomepage/comment/doctorproduction',
    get_webcomments: '/api/web/v2/comment/getwebcomments',
    delete_comment: '/api/web/v2/comment/deletecomment'
}
